import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategorySection() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-12 md:py-16 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            分类探索
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按分类浏览你感兴趣的黑料内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={scrollToTop}
              className="group flex flex-col items-center text-center p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300/50 hover:bg-background-50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 line-clamp-2 mb-2">{cat.description}</p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}